// @ts-nocheck
// import TextInput from './inputText';
import PropTypes from 'prop-types';
// import PasswordInput from './inputPassword';
import InputSelect from './inputSelect';
import InputSelectNormal from './inputSelectNormal';
import TextInput from './inputText';
import TextAreaInput from './inputTextArea';
import PhoneNumberInput from './InputPhone';
// import TextAreaInput from './inputTextArea';
// import InputDateTime from './inputDateTime';
// import InputRating from './inputRating';
// import InputFile from './inputFile';

type ArrayType = {
  title: string;
  placeholder: string;
  type: string;
  value: any;
  name: string;
  options?: Array<any>;
  rules: any;
  error: string;
  hidden?: boolean;
  note?: string;
  disabled?: boolean;
  rightAddon?: React.ReactNode;
  onSelectSearch?: (inputValue: string, callback: (options: any) => void) => void;
}

type InputFormType = {
  formData: Array<ArrayType>;
  targetMutation: Array<ArrayType>;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>, mutation:Array<ArrayType>, setTarget:Function) => void;
  setTargetMutation: (e:Array<any>) => void;
  containerStyle: string;
}

const InputForm = ({formData, targetMutation, setTargetMutation, onChange, containerStyle}: InputFormType) => {
  const handleDataChange = (event:any) => {
    onChange(event, targetMutation, setTargetMutation)
  }

  return (
    <div className={containerStyle}>
      {formData.map((result, index) => {
        return !result.hidden && (
          <div key={index} className='tw-w-full'>
            <div className='tw-text-[14px] tw-text-transparent tw-bg-clip-text tw-bg-gradient-to-r tw-from-dark-green tw-from-30% tw-to-light-green tw-to-90% tw-w-fit tw-font-semibold tw-mb-[2px]'>{result.title}</div>
            {(result.type === 'text' || result.type === 'number' ) && <TextInput onChange={handleDataChange} data={result}/>}
            {result.type === 'textarea' && <TextAreaInput onChange={handleDataChange} data={result}/>}
            {/* 
            {(result.type === 'file') && <InputFile onChange={handleDataChange} data={result}/>}
            
            {result.type === 'password' && <PasswordInput onChange={handleDataChange} data={result}/>} */}
            {result.type === 'select' && <InputSelect onChange={handleDataChange} data={result}/>}
            {result.type === 'select-normal' && <InputSelectNormal onChange={handleDataChange} data={result}/>}
            {result.type === 'phone' && <PhoneNumberInput onChange={handleDataChange} data={result}/>}
            {/* {result.type === 'date-time-picker' && <InpuInputSelectNormaltDateTime onChange={handleDataChange} data={result}/>}
            {result.type === 'rating' && <InputRating onChange={handleDataChange} data={result}/>} */}
            {/* {result.type === 'radio' && <InputRadio onChange={onChange} {...result}/>} */}
            {/* {result.type === 'date-range' && <InputRange onChange={onChange} data={result}/>}
            {result.type === 'date-year' && <InputYear onChange={onChange} data={result}/>}
            {result.type === 'date-month' && <InputMonth onChange={onChange} data={result}/>} */}
            <div className='tw-flex tw-flex-col'>
              {result.note && (<label className='tw-text-sm tw-text-gray-500'>{result.note}</label>)}
              {result.error && (<label className='tw-text-sm tw-text-red-600'>{result.error}</label>)}
            </div>
          </div>
        )
      })}
    </div>
  )
}


InputForm.propTypes = {
  formData: PropTypes.array,
  onChange: PropTypes.func,
  containerStyle: PropTypes.string
};

InputForm.defaultProps = {
  onChange: () => {},
  formData: [
    {
      title: '',
      placeholder: '',
      type: '',
      value: ''
    }
  ],
  containerStyle: 'flex flex-col gap-y-4 w-full'
};

export default InputForm;